import {SvgIcon} from '@mui/material';

export default function PlayButtonIcon() {
	return (
		<SvgIcon className="w-14 h-14" width="36" height="36" viewBox="0 0 36 36">
			<path opacity="0.8"
			      d="M31.6202 23.13L31.6202 12.87C31.6202 11.19 30.7202 9.62994 29.2652 8.77494L20.3552 3.62995C18.9002 2.78995 17.1002 2.78995 15.6302 3.62995L6.72025 8.77494C5.26525 9.61494 4.36524 11.175 4.36524 12.87L4.36524 23.1299C4.36524 24.8099 5.26525 26.37 6.72024 27.225L15.6302 32.37C17.0852 33.21 18.8852 33.21 20.3552 32.37L29.2652 27.225C30.7202 26.37 31.6202 24.825 31.6202 23.13Z"
			      fill="white"/>
			<path
				d="M22.1998 19.0391C22.9998 18.5773 22.9998 17.4226 22.1998 16.9607L16.7998 13.843C15.9998 13.3811 14.9998 13.9585 14.9998 14.8822L14.9998 21.1176C14.9998 22.0414 15.9998 22.6187 16.7998 22.1568L22.1998 19.0391Z"
				fill="#0755E4"/>
		</SvgIcon>
	);
}
